import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { GetLocalStroge } from '../functions/local-storage.function';
import { CommonService } from '../services/common.service';

/**
 * This service use for check user is login or not
 * .if not login redirect to login page.
 */
@Injectable({
  providedIn: 'root'
})
export class NotAuthGuardService implements CanActivate {


  constructor(
    public router: Router,
    private commonService: CommonService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const { token } = GetLocalStroge('login');
    if (token) {
      this.router.navigate(['/']);
      this.commonService.showErrorSnackBar('ابتدا از اکانت فعلی خارج شوید');
      return false;
    }
    return true;
  }
}

